import { useRouter } from 'next/router';
import { PolkaConnectInfo as BaseConnectInfo } from '@/shared/components/PolkadotConnectionButton/index';
import useBoolean from '@/shared/hooks/useBoolean';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import { OffboardModal } from './Dashboard/OffboardModal';
import useDisconnectWithWarning from '../hooks/useDisconnectWithWarning';
import { useExtrinsicSDK, useStateChainAccount } from '../hooks/useStateChainAccount';

export const PolkaConnectInfo = () => {
  const router = useRouter();
  const { flipBalance, accountInfo } = useStateChainAccount();
  const { selectedAccount } = usePolkadot();
  const { disconnect, disconnectWarning } = useDisconnectWithWarning();

  const { sendExtrinsic: redeemFlip } = useExtrinsicSDK('redeemFlip');

  const {
    value: offboardModalOpen,
    setTrue: openOffboardModal,
    setFalse: closeOffboardModal,
  } = useBoolean(false);

  return (
    <>
      <BaseConnectInfo
        account={selectedAccount}
        flipBalance={flipBalance}
        redeemFlip={redeemFlip}
        hasOnboarded={accountInfo?.role === 'liquidity_provider'}
        additionalActions={[
          {
            content: <span className="font-aeonikMedium">Close account</span>,
            onClick: openOffboardModal,
          },
        ]}
        type="liquidity-provider"
        connectText="Connect wallet"
        openAccountModal={() =>
          router.push({ pathname: '/', query: { redirectUrl: router.asPath } })
        }
        onDisconnect={disconnect}
      />
      <OffboardModal open={offboardModalOpen} onClose={closeOffboardModal} />
      {disconnectWarning}
    </>
  );
};
